import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="map"
export default class extends Controller {
  static targets = ['map']
  static values = {
    pins: Array,
    centerPin: Object
  };
  markers = [];
  map = null;

  connect() {
    console.log(this.pinsValue)
    this.map = new google.maps.Map(this.mapTarget, {
      center: {lat: parseFloat(this.centerPinValue.latitude), lng: parseFloat(this.centerPinValue.longitude)},
      zoom: 13
    })

    // render the center pin
    this.addMarker(0, this.centerPinValue);

    // add the other pins
    this.pinsValue.forEach((pin, index) => {
      this.addMarker(index + 1, pin);
    });
       
  }

  addMarker(index, pin) {
    const marker = new google.maps.Marker({
      position: {lat: parseFloat(pin.latitude), lng: parseFloat(pin.longitude)},
      map: this.map
    })

    this.markers.push(marker)
  }
}